<script setup lang="ts">
import HeaderActions from "~/components/Header/HeaderActions.vue";
import { useHeader } from "~/composables/header/useHeader";

const header = useHeader();
</script>

<template>
  <div class="relative">
    <nav class="header">
      <ClientOnly>
        <div class="heading_2_demi">
          <span v-if="header.pageName.value">{{ header.pageName.value }}</span>
        </div>
      </ClientOnly>
      <HeaderActions />
    </nav>
  </div>
</template>

<style scoped lang="scss">
.header {
  @apply flex flex-row items-center justify-between gap-[18px] px-[32px];
  /* Pinned to the height every layout subtracts, so a taller trigger cannot push the page past 100vh. */
  height: var(--header_height);
  background: var(--white-main);
  border-bottom: 1px solid var(--grey-lightest);
}
</style>
